import styled, { css } from 'styled-components';
import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';

export const Container = styled.div``;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
  margin-bottom: 10px;
`;

export const Cancel = styled.button`
  color: #474d66;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  outline: 0;
`;

export const Done = styled.button`
  color: ${COLORS_FLAT.b401};
  font-weight: 500;
  font-size: 14px;
  margin-left: 40px;
  margin-right: 16px;
  background: none;
  border: none;
  outline: 0;
  :disabled {
    color: ${COLORS_FLAT.n500};
    pointer-events: none;
    cursor: not-allowed;
  }
`;
interface DateDivProps {
  width?: number;
  isHidden?: boolean;
  active?: boolean;
  pinnedFields?: boolean;
}

export const BigEditableInput = styled.textarea<DateDivProps>`
  align-items: flex-start;
  min-height: ${({ pinnedFields }) => (pinnedFields ? '22px' : '50px')};
  width: 100%;
  resize: none;
  font-family: 'Poppins', sans-serif;
  text-align: ${({ pinnedFields }) => pinnedFields && 'end'};

  ::-webkit-scrollbar {
    width: ${({ pinnedFields }) => (pinnedFields ? '0' : '24px')};
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  color: #474d66;
  background: #fff;

  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 4px;
  background: ${beam.color.pureWhite};
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${({ pinnedFields }) => (pinnedFields ? '0' : '4px 0')};
  font-size: 14px;
  margin-top: ${({ pinnedFields }) => pinnedFields && '1px'};

  ::placeholder {
    color: #c1c4d6;
    opacity: 1;
    font-style: italic;
  }

  ${({ active }) =>
    active
      ? css`
          background: #fff;
          border-color: #d8dae5;
          border-radius: 4px;
          padding: 4px 8px;
          min-height: 150px;
          text-align: start;
          &[data-error='true'] {
            border-color: ${COLORS_FLAT.r400};
          }
        `
      : css`
          :hover {
            padding-left: 8px;
            padding-right: 8px;
            border-color: ${beam.background.card};
            background: ${beam.background.card};
          }
        `}
`;
